<div class="d-flex align-items-center justify-content-between">
	<h1>{{'Media_Recommended' | translate }}</h1>

	<a [uiSref]="PORTAL_MEDIA_ALL_STATE" [uiParams]="srefParams">
		{{'Dashboard_SeeAll' | translate }}
	</a>
</div>

<div [ngClass]="styles.videosContainer" infiniteScroll (scrolled)="loadNextPage()" [infiniteScrollDisabled]="pauseInfiniteScroll" [scrollWindow]="true" [infiniteScrollDistance]="2">

	<video-tile *ngFor="let video of videos" [isResponsiveTile]="false" [video]="video" [config]="MediaState.videoPlaybackConfig" [hasMediaEditAuth]="hasMediaEditAuth" [userId]="userId" [isGuest]="isGuest">
	</video-tile>
</div>

@if(scrollExpired) {
	<button vbBtnSecondary (click)="resetScroll()" class="d-block ms-auto me-auto mb-4">
		{{ 'UI_ClickToRefreshTable' | translate }}
	</button>
}
